<script lang="ts" module>
	let openMageSearch: OpenMageSearch; // Share instance across component instances
</script>

<script lang="ts">
	// @ts-expect-error miss type declaration
	import OpenMageSearch from '@spacefoot/openmage-elastic';
	import '@spacefoot/openmage-elastic/style.css';
	import { pushState } from '$app/navigation';
	import { page } from '$app/state';
	import { thumbnailUrl } from '$lib';
	import { m } from '$lib/paraglide/messages.js';
	import { onMount } from 'svelte';

	const {
		class: className = '',
		inputClass = '',
		iconClass = '',
		containerClass = '',
	}: {
		class?: string;
		inputClass?: string;
		iconClass?: string;
		containerClass?: string;
	} = $props();

	onMount(() => {
		openMageSearch ??= new OpenMageSearch({
			target: document.body,
			props: {
				store: page.data.store.store_id,
				server: '/api/search',
				primaryColor: '#E22525',
				xmas: false,
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				getMediaUrl(image: string, config: unknown, fallback: number) {
					// TODO: placeholder
					return thumbnailUrl(page.data.store.media_base_url, 'product/' + image, 600);
				},
				skipOtherWebsite: true,
			},
		});

		openMageSearch.$on('close', () => {
			if (page.state.showSearch) {
				pushState('', { showSearch: false });
			}
		});

		return () => {
			openMageSearch?.close();
			document.querySelector('#searchWindow')?.remove();
		};
	});

	$effect(() => {
		if (page.state.showSearch) {
			openMageSearch?.open();
		} else {
			openMageSearch?.close();
		}
	});
</script>

<div class={['relative', className]}>
	<input
		id="search"
		class={['w-full cursor-pointer text-sm', inputClass]}
		type="text"
		placeholder={m.search()}
		onfocus={() => pushState('', { showSearch: true })}
	/>

	<div class={['absolute top-0 right-0 flex h-full cursor-pointer items-center', containerClass]}>
		<div class={['icon-[mdi--magnify] size-6', iconClass]}></div>
	</div>
</div>
